import React, { createContext, useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

export interface TenantContextProps {
  tenantName: string;
  subdomain: string;
  logoUrl: string;
  loading: boolean;
}

export const TenantContext = createContext<TenantContextProps>({
  tenantName: 'T-file Platform',
  subdomain: 'morenese',
  logoUrl: '',
  loading: true
});

export const TenantProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [tenantName, setTenantName] = useState('T-file Platform');
  const [subdomain, setSubdomain] = useState('morenese');
  const [logoUrl, setLogoUrl] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initialize from localStorage cache if available
    const cachedName = localStorage.getItem('school_name_cache');
    const cachedLogo = localStorage.getItem('school_logo_cache');
    
    if (cachedName) {
      setTenantName(cachedName);
    }
    if (cachedLogo) {
      setLogoUrl(cachedLogo);
    }

    const fetchDetails = async () => {
      try {
        const data = await settingsService.getSchoolSettings();
        if (data) {
          if (data.name) {
            setTenantName(data.name);
            localStorage.setItem('school_name_cache', data.name);
          }
          if (data.logo_url) {
            setLogoUrl(data.logo_url);
            localStorage.setItem('school_logo_cache', data.logo_url);
          }
        }
      } catch (err) {
        // Silently fail if unauthenticated or errored
      } finally {
        setLoading(false);
      }
    };

    // Only attempt to fetch settings if the user is logged in as a tenant user
    const token = localStorage.getItem('school_saas_token');
    if (token) {
      fetchDetails();
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <TenantContext.Provider value={{ tenantName, subdomain, logoUrl, loading }}>
      {children}
    </TenantContext.Provider>
  );
};
